export default __webpack_public_path__ + "static/media/image.b8351d13.svg";